// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"73":"Unatuhorized","74":"About","305":"Beneficiaries","424":"AddBeneficiaries","438":"Login","892":"PageNotFound"}[chunkId] || chunkId) + "." + {"73":"ccab7db6","74":"e9f84e4a","77":"24959a24","305":"045e355b","424":"73dcf339","438":"2927baa9","459":"800ebd46","892":"be8cbef6"}[chunkId] + ".js";
};